import { useAuthStore } from '@/store/auth-store';
import { sessionScope } from '@/features/auth/session-scope';

// Only this small key module enters the realtime startup bundle.
export const contactExportKey = (scope = sessionScope(useAuthStore.getState())) => ['contact-exports', scope] as const;
export const isCurrentContactExportKey = (key: readonly unknown[]) => key[0] === 'contact-exports' && key[1] === sessionScope(useAuthStore.getState());
